<template>
    <v-container grid-list-md fluid style="overflow: hidden; height: calc(100vh - 64px)">
        <template v-if="isAuthorized">
            <v-row
                no-gutters
                :class="$vuetify.display.mobile ? 'pb-0 pt-3' : 'my-3 justify-center'"
                v-if="!auditCheck"
            >
                <v-col :cols="$vuetify.display.mobile ? '12' : '3'">
                    <!-- <v-select
                            :items="accounts"
                            :item-title="formatBankAccount"
                            item-value="id"
                            label="Compte bancaire"
                            v-model="selectedAccount"
                            class="elevation-0"
                            outlined
                            dense
                            hide-details
                            :readonly="accounts.length <= 1"
                        ></v-select> -->
                    <v-menu offset-y v-if="account && accounts && accounts.length">
                        <template #activator="{ props }">
                            <v-input
                                class="bg-primary-foreground rounded-xl v-field v-field--flat px-4 py-2"
                                v-bind="props"
                                hide-details
                            >
                                <div>
                                    {{ formatBankAccount(account) }}
                                    <template
                                        v-if="
                                            account &&
                                            account.currentError &&
                                            account.currentError.length > 0
                                        "
                                    >
                                        <span style="color: red">
                                            - {{ account.currentError }}
                                        </span>
                                    </template>
                                </div>
                            </v-input>
                        </template>
                        <v-list>
                            <v-list-item
                                v-for="(item, index) in accounts"
                                :key="index"
                                @click="selectedAccount = item.id"
                            >
                                <v-list-item-title>
                                    {{ formatBankAccount(item) }}
                                </v-list-item-title>
                                <template v-slot:append>
                                    <span style="color: red" class="mr-4">{{
                                        item.currentError
                                    }}</span>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
                <v-col v-if="isAccountingUser && !$vuetify.display.mobile" cols="auto">
                    <AuditCheckAlertButton
                        v-if="showReconciliationDiscrepancyAlertButton"
                        auditCheckType="Bank"
                        :unreconciledBalancesAccountNames="unreconciledBalancesAccountNames"
                        @auditCheckAlertButtonClicked="onAuditCheckAlertButtonClick"
                    />
                    <AuditCheckOkButton
                        v-if="showReconciliationOkButton"
                        auditCheckType="Bank"
                        :accountingPeriodId="accountingPeriod?.id"
                        :companyId="selectedCompany.id"
                    />
                    <BankReconciliationDiscrepancyDialog
                        v-if="showBankReconciliationDiscrepancyDialog"
                        v-model="showBankReconciliationDiscrepancyDialog"
                        :accountingPeriodId="accountingPeriod?.id"
                        :companyId="selectedCompany.id"
                        width="800px"
                    />
                </v-col>
                <v-col
                    cols="2"
                    v-if="!$vuetify.display.mobile && pagination.totalItems"
                    class="pl-2"
                >
                    <v-text-field
                        readonly
                        :model-value="
                            'Recettes : ' +
                            (selected.length
                                ? newCommonFormatCurrency(selectedAmountDebit, undefined)
                                : newCommonFormatCurrency(amountDebit, undefined))
                        "
                    />
                </v-col>
                <v-col
                    cols="2"
                    v-if="!$vuetify.display.mobile && pagination.totalItems"
                    class="pl-2"
                >
                    <v-text-field
                        readonly
                        :model-value="
                            'Dépenses : ' +
                            (selected.length
                                ? newCommonFormatCurrency(selectedAmountCredit, undefined)
                                : newCommonFormatCurrency(amountCredit, undefined))
                        "
                    />
                </v-col>
                <v-spacer />
                <v-col cols="2" class="pl-2" v-if="isAccountingUser && !$vuetify.display.mobile">
                    <v-btn-primary
                        size="large"
                        block
                        @click="reconciliateCompany()"
                        data-cy="bank-reconciliate"
                    >
                        Lettrage auto
                    </v-btn-primary>
                </v-col>
                <v-col
                    cols="2"
                    class="pl-2"
                    v-if="
                        isAccountingUser &&
                        account &&
                        account.id &&
                        account.budgetInsightId &&
                        !$vuetify.display.mobile
                    "
                >
                    <v-btn-primary block size="large" @click="updateBankAccount()">
                        Synchroniser
                    </v-btn-primary>
                </v-col>
            </v-row>
            <v-row no-gutters :class="$vuetify.display.mobile ? 'py-0' : 'pb-2'">
                <v-col
                    cols="2"
                    v-if="
                        currentUser.profile.configuration.bankTransaction.import &&
                        !$vuetify.display.mobile
                    "
                >
                    <v-btn-primary
                        block
                        size="large"
                        @click="importWizard = true"
                        :disabled="!!auditCheck"
                        data-cy="bank-import"
                    >
                        Importer
                    </v-btn-primary>
                </v-col>
                <v-col
                    :cols="$vuetify.display.mobile ? '11' : '9'"
                    :class="$vuetify.display.mobile ? 'pt-1' : ''"
                >
                    <oss-filter-bar
                        :mode="'bankTransaction'"
                        v-model:type="amountType"
                        v-model:text="search"
                        v-model:tags="bankTransactionTags"
                        v-model:startDate="beginDate"
                        v-model:endDate="endDate"
                        v-model:status="reconciliationStatus"
                        :minPrice="minAmount"
                        @update:minPrice="(minPrice) => (minAmount = `${minPrice}`)"
                        v-model:maxPrice="maxAmount"
                        @update:maxPrice="(maxPrice) => (maxAmount = `${maxPrice}`)"
                        v-model:payBy="payBy"
                        :limitMinPrice="limitMinAmount"
                        :limitMaxPrice="limitMaxAmount"
                        :types-list="amountTypes"
                        :status-list="
                            allReconciliationStatus.map((status) => {
                                return { value: status, text: formatStatus(status) };
                            })
                        "
                        :payByList="payByList"
                        :companyId="selectedCompany.id"
                        v-model:auditCheck="auditCheck"
                        :auditChecks="auditChecks"
                        v-model:displayGraph="displayGraph"
                        :selectedAccount="selectedAccount"
                        v-model:partitionTagId="partitionTagId"
                        data-cy="Bank-filter"
                    />
                </v-col>
                <v-col cols="1" v-if="!$vuetify.display.mobile" class="d-flex justify-end">
                    <TutorialButtonDialog :starterComponents="'Bank;'" />
                </v-col>
            </v-row>
            <!-- GRAPH -->
            <div>
                <BankFlow
                    v-if="displayGraph"
                    :companyId="selectedCompany.id"
                    :startDates="{ startDate: beginDate, endDate: endDate }"
                    @graphDate="graphDate = $event"
                    :selectedAccount="selectedAccount"
                >
                </BankFlow>
            </div>
            <v-card v-if="!accounts.length && !loading" class="default_card text-center">
                <v-card-title primary-title>
                    Ajoutez un compte bancaire pour visualiser vos transactions
                </v-card-title>
                <v-card-text v-if="addBankAccountAvailable">
                    <v-btn @click="connectClicked" :loading="connectLoading" size="small">
                        Ajoutez un compte bancaire
                    </v-btn>
                </v-card-text>
            </v-card>
            <v-row no-gutters v-if="!$vuetify.display.mobile">
                <v-col :cols="bankTransactionIdOpen ? 8 : 12">
                    <oss-data-table
                        v-model="selected"
                        :show-select="true"
                        :headers="headers"
                        :items="items"
                        v-model:page="pagination.page"
                        v-model:sort-by="sortBy"
                        v-model:sort-desc="pagination.descending"
                        :items-length="pagination.totalItems"
                        v-model:items-per-page="pagination.rowsPerPage"
                        :items-per-page-options="[5, 10, 25]"
                        v-model:loading="loading"
                        class="table"
                        hide-default-footer
                        fixed-header
                        return-object
                        height="71vh"
                        style="border-collapse: collapse"
                        data-cy="bank-table"
                    >
                        <!-- HEADER TEMPLATE -->
                        <template v-slot:header>
                            <div no-gutters class="d-flex align-center">
                                <template v-if="isAccountingUser || isAccountingClientOfIOP">
                                    <template v-if="isAccountingUser">
                                        <v-btn-ternary
                                            :disabled="disabledWithoutInvoice"
                                            @click="
                                                showCreateBankTransactionMessageDialog =
                                                    !showCreateBankTransactionMessageDialog
                                            "
                                            icon="$fa-comments"
                                        >
                                        </v-btn-ternary>
                                        <v-btn-ternary
                                            @click="
                                                companyType = 'SUPPLIER';
                                                thirdPartyDialog = !thirdPartyDialog;
                                            "
                                            class="ml-2"
                                            :disabled="disabledThirdPartyCompany()"
                                        >
                                            Fournisseur
                                        </v-btn-ternary>
                                        <v-btn-ternary
                                            @click="
                                                companyType = 'CUSTOMER';
                                                thirdPartyDialog = !thirdPartyDialog;
                                            "
                                            class="ml-2"
                                            :disabled="disabledThirdPartyCompany()"
                                        >
                                            Client
                                        </v-btn-ternary>
                                    </template>
                                    <AccountableAccountVue
                                        :title="subAccountableAccountTitle"
                                        :showLabel="subDefaultParams"
                                        :showValidation="false"
                                        :companyId="selectedCompany.id"
                                        :inAccountableAccountType="subInAccountableAccountType"
                                        :embeddedInput="true"
                                        :editAccountableAccount="subDefaultParams"
                                        :inAccountableAccountNames="subSelectedAccountableAccounts"
                                        :defineThirdParty="true"
                                        :activateFreeTag="subDefaultParams"
                                        :bankTransactionId="
                                            selected.length === 1 ? selected[0].id : ''
                                        "
                                        :publishedAccounts="!subDefaultParams"
                                        @close="closeAccountableAccount"
                                        @select-accountableAccount="setAccountableAccount($event)"
                                        :key="refreshKey"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <div
                                                class="d-flex align-center"
                                                v-if="isAccountingUser"
                                            >
                                                <v-btn-ternary
                                                    class="ml-2"
                                                    :disabled="disabledThirdPartyCompany()"
                                                    @click="socialAccountableAccount()"
                                                    v-bind="props"
                                                >
                                                    Social
                                                </v-btn-ternary>
                                                <v-btn-ternary
                                                    class="ml-2"
                                                    :disabled="disabledThirdPartyCompany()"
                                                    @click="stateAccountableAccount()"
                                                    v-bind="props"
                                                >
                                                    Etat
                                                </v-btn-ternary>
                                                <v-btn-ternary
                                                    class="ml-2"
                                                    :disabled="disabledThirdPartyCompany()"
                                                    @click="miscelleanousAccountableAccount()"
                                                    v-bind="props"
                                                >
                                                    Autres
                                                </v-btn-ternary>
                                            </div>
                                            <div
                                                class="d-flex align-center"
                                                v-if="isAccountingClientOfIOP"
                                            >
                                                <v-btn-ternary
                                                    ref="asignButton"
                                                    class="ml-2"
                                                    :disabled="isIopAccountableAccountDisabled"
                                                    @click="
                                                        incomingOutgoingPaymentAccountableAccount()
                                                    "
                                                    v-bind="props"
                                                >
                                                    Affecter
                                                </v-btn-ternary>
                                            </div>
                                        </template>
                                    </AccountableAccountVue>
                                    <template v-if="isAccountingUser">
                                        <v-btn-ternary
                                            class="ml-2"
                                            :disabled="disabledZTillReconciliation"
                                            v-if="showZTillReconciliation"
                                            @click="showZTillDialog = true"
                                        >
                                            Z de caisse
                                        </v-btn-ternary>
                                        <v-btn-ternary
                                            class="ml-2"
                                            :disabled="
                                                disabledValidateAutoAllocationAndReconciliation
                                            "
                                            @click="validateAutoAllocationAndReconciliation"
                                        >
                                            Valider
                                        </v-btn-ternary>
                                        <v-btn-ternary
                                            class="ml-2"
                                            :disabled="disabledAutoSalesReconciliation"
                                            v-if="!declareSalesInvoices"
                                            @click="
                                                autoSalesReconciliationDialog =
                                                    !autoSalesReconciliationDialog
                                            "
                                            :loading="autoSalesReconciliationLoading"
                                        >
                                            Encaissement
                                        </v-btn-ternary>
                                    </template>
                                </template>
                                <multiple-free-tagging
                                    :company="selectedCompany"
                                    :company-tags="allCompanyTags"
                                    :selected-bank-transactions="selected"
                                    @selected-tags="onMultiTagguingApplied"
                                />
                                <v-menu offset-y>
                                    <template v-slot:activator="{ props }">
                                        <v-btn-icon icon="$dots_vertical" v-bind="props" />
                                    </template>
                                    <v-list>
                                        <v-list-item
                                            :disabled="disabledWithoutInvoice"
                                            @click="onWithoutInvoiceClick"
                                            v-if="isAccountingUser"
                                        >
                                            <v-list-item-title>
                                                Justificatif manquant
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            v-if="showTransactionType && isAccountingUser"
                                            :disabled="disabledTransactionType"
                                            @click="openTransactionTypeDialog(null)"
                                        >
                                            <v-list-item-title>
                                                Type de transaction
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            :disabled="
                                                !account ||
                                                !account.id ||
                                                account.id === 'ALL' ||
                                                !selected.length
                                            "
                                            @click="analyseBankTransactionWordings()"
                                            v-if="isAccountingUser"
                                        >
                                            <v-list-item-title>
                                                Analyser les libellés
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-divider v-if="isAccountingUser" />
                                        <v-list-item
                                            :disabled="!showDeallocation"
                                            @click="openDeallocateDialog()"
                                            :color="showDeallocation ? '' : 'error'"
                                            v-if="isAccountingUser"
                                        >
                                            <v-list-item-title>
                                                Retirer l'affectation
                                            </v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small">$delete</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item @click="showTag = !showTag">
                                            <v-list-item-title>{{
                                                showTag
                                                    ? "Cacher les étiquettes"
                                                    : "Afficher les étiquettes"
                                            }}</v-list-item-title>
                                            <template #append>
                                                <v-icon size="small">$oss-eye</v-icon>
                                            </template>
                                        </v-list-item>
                                        <v-list-item
                                            :disabled="disabledDeleteBT"
                                            @click="showDeleteBankTransactionsDialog = true"
                                            :color="disabledDeleteBT ? '' : 'error'"
                                        >
                                            <v-list-item-title> Supprimer </v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small"> $delete </v-icon>
                                            </template>
                                        </v-list-item>

                                        <v-tooltip top v-if="disabledRestoreBT">
                                            <template v-slot:activator="{ props }">
                                                <div style="height: fit-content" v-bind="props">
                                                    <v-list-item disabled>
                                                        <v-list-item-title>
                                                            Restaurer
                                                        </v-list-item-title>
                                                        <template v-slot:append>
                                                            <v-icon size="small">
                                                                $oss-edit
                                                            </v-icon>
                                                        </template>
                                                    </v-list-item>
                                                </div>
                                            </template>

                                            <template v-for="line of canBeRestoredTooltipMessages">
                                                <h4>
                                                    {{ line }}
                                                </h4>
                                            </template>
                                        </v-tooltip>

                                        <v-list-item v-else @click="restoreBankTransactions">
                                            <v-list-item-title> Restaurer </v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small"> $oss-edit </v-icon>
                                            </template>
                                        </v-list-item>

                                        <v-tooltip top v-if="disabledRestoreBT">
                                            <template v-slot:activator="{ props }">
                                                <div style="height: fit-content" v-bind="props">
                                                    <v-list-item disabled>
                                                        <v-list-item-title>
                                                            Supprimer définitivement
                                                        </v-list-item-title>
                                                        <template v-slot:append>
                                                            <v-icon size="small"> $delete </v-icon>
                                                        </template>
                                                    </v-list-item>
                                                </div>
                                            </template>

                                            <template v-for="line of canBeRestoredTooltipMessages">
                                                <h4>
                                                    {{ line }}
                                                </h4>
                                            </template>
                                        </v-tooltip>

                                        <v-list-item
                                            v-else
                                            color="red"
                                            @click="dialogDeletePermanentlySelectedBTs = true"
                                        >
                                            <v-list-item-title>
                                                Supprimer définitivement
                                            </v-list-item-title>
                                            <template v-slot:append>
                                                <v-icon size="small"> $delete </v-icon>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </div>
                        </template>
                        <!-- BODY TEMPLATE -->
                        <template #no-data>
                            <p v-if="account && !account.initialSyncDone">
                                Synchronisation en cours, les opérations appara&#xee;tront bientôt
                            </p>
                        </template>
                        <template v-slot:item="props">
                            <tr
                                @click.stop="onItemClick(props.item)"
                                class="cursor-pointer"
                                :style="
                                    props.item.id === bankTransactionIdOpen
                                        ? 'box-shadow: inset 0px 0px 0px 2px #F9B12A'
                                        : ''
                                "
                                :data-cy="'Bank_table_' + props.index"
                            >
                                <td class="text-center" style="width: 64px">
                                    <v-checkbox
                                        @click.stop
                                        @update:model-value="props.select()"
                                        :ripple="false"
                                        hide-details
                                        :model-value="props.isSelected"
                                    />
                                </td>
                                <td class="text-center">
                                    {{ formatDateForUI(props.item.dateDebit) }}
                                </td>
                                <td>
                                    <v-row no-gutters>
                                        <v-col :cols="12" class="body-1">
                                            <template v-if="props.item.accountingLineTags">
                                                <v-chip-tag
                                                    :ripple="false"
                                                    v-for="(tag, index) of props.item
                                                        .accountingLineTags"
                                                    :key="index"
                                                    class="text mr-1"
                                                >
                                                    <span
                                                        :style="
                                                            'color:' +
                                                            props.item.labelTextColor +
                                                            ';'
                                                        "
                                                        >{{ tag.name }}</span
                                                    >
                                                </v-chip-tag>
                                            </template>
                                            <span>{{
                                                props.item.wordingDisplay ||
                                                props.item.wordingOriginal
                                            }}</span>
                                            <v-icon
                                                color="secondary"
                                                v-if="
                                                    props.item.uniqueExport &&
                                                    props.item.uniqueExport.id
                                                "
                                                size="small"
                                                location="end"
                                            >
                                                $oss-already-downloaded
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="body-2 d-flex align-center">
                                            <template v-if="account && account.id === 'ALL'">
                                                <v-icon size="small"> $fa-university </v-icon>
                                                <span class="px-2">{{
                                                    props.item.account.name
                                                }}</span>
                                            </template>

                                            <v-icon
                                                size="small"
                                                left
                                                v-if="props.item.account.type === 'CASH_BOX'"
                                                @click.stop="openTransactionTypeDialog(props.item)"
                                            >
                                                $fa-cash-register
                                            </v-icon>
                                            <v-icon
                                                size="small"
                                                left
                                                v-else-if="getTransactionTypeIcon(props.item)"
                                                @click.stop="openTransactionTypeDialog(props.item)"
                                            >
                                                {{ getTransactionTypeIcon(props.item) }}
                                            </v-icon>
                                            <v-avatar
                                                @click.stop="openTransactionTypeDialog(props.item)"
                                                color="grey"
                                                class="subheading white--text mr-1"
                                                size="18"
                                                v-else
                                                >{{
                                                    getTransactionTypeBigram(props.item)
                                                }}</v-avatar
                                            >
                                            <span
                                                @click.stop="openTransactionTypeDialog(props.item)"
                                                >{{ getTransactionTypeText(props.item) }}</span
                                            >
                                            <v-icon
                                                size="small"
                                                left
                                                right
                                                v-if="props.item.thirdPartyCompany"
                                                >$bookmark</v-icon
                                            >
                                            <span v-if="props.item.allSuppliers" class="ml-2"
                                                >Fournisseur :</span
                                            >
                                            <span v-else-if="props.item.allCustomers" class="ml-2">
                                                Client :
                                            </span>
                                            <span
                                                v-if="props.item.thirdPartyCompanies"
                                                :style="
                                                    props.item.containtsThirdPartyCompanySuggestion
                                                        ? 'color:magic;'
                                                        : ''
                                                "
                                                @click.stop="
                                                    openAccountableAccountWithSuggestion(props.item)
                                                "
                                                class="ml-2"
                                                >{{ props.item.thirdPartyCompanies }}</span
                                            >
                                            <v-icon
                                                size="x-small"
                                                left
                                                right
                                                v-if="
                                                    props.item.containtsThirdPartyCompanySuggestion
                                                "
                                                color="ternary"
                                                class="ml-2"
                                                @click.stop="
                                                    openAccountableAccountWithSuggestion(props.item)
                                                "
                                                >$fa-magic</v-icon
                                            >
                                            <!-- <span v-if="props.item.all">{{ props.item.containsSuppliers }}</span> -->

                                            <v-icon
                                                size="x-small"
                                                left
                                                right
                                                v-if="props.item.allUsers"
                                                >$fa-user</v-icon
                                            >
                                            <template v-if="props.item.allUsers">
                                                Collaborateur : {{ props.item.users }}</template
                                            >
                                            <span
                                                :style="
                                                    props.item.containtsThirdPartyCompanySuggestion
                                                        ? 'color:magic;'
                                                        : ''
                                                "
                                                @click.stop="
                                                    openAccountableAccountWithSuggestion(props.item)
                                                "
                                                >{{ props.item.userSuggestion }}</span
                                            >
                                            <v-icon
                                                size="x-small"
                                                left
                                                right
                                                v-if="props.item.containsUserSuggestion"
                                                color="ternary"
                                                class="ml-2"
                                                @click.stop="
                                                    openAccountableAccountWithSuggestion(props.item)
                                                "
                                                >$fa-magic</v-icon
                                            >
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="pb-1">
                                            <FreeTag
                                                v-if="
                                                    showTag &&
                                                    currentUser.profile.configuration.tag.write
                                                "
                                                :company="selectedCompany"
                                                :companyTags="allCompanyTags"
                                                :bankTransaction="props.item"
                                                @focus="onFreeTagFocus"
                                                @blur="onFreeTagBlur"
                                                :key="props.item.id"
                                            />
                                            <!-- <div v-if="props.item.chatStatus">
                                            <v-icon  size="small" v-if="props.item.chatStatusIcon" :style="'color:' + props.item.chatStatusColor">
                                                {{props.item.chatStatusIcon}}
                                            </v-icon>
                                            <a class="ml-2" :style="'color:'+ props.item.chatStatusColor">{{props.item.chatStatus}}</a>
                                        </div> -->
                                        </v-col>
                                    </v-row>
                                </td>
                                <td class="text-center">
                                    <v-btn-icon
                                        icon="$oss-edit"
                                        @click.stop="openEditWording(props.item)"
                                        :data-cy="'Bank_BT_Dialog_' + props.index"
                                        size="small"
                                    />
                                </td>
                                <td
                                    class="text-right"
                                    :style="props.item.amount < 0 ? 'color:red;' : ''"
                                >
                                    {{ newCommonFormatCurrency(props.item.amount, undefined) }}
                                </td>
                                <td v-if="isAccountingUser && props.item.status === 'DELETED'">
                                    <v-chip
                                        class="px-2"
                                        label
                                        variant="outlined"
                                        color="red"
                                        size="x-small"
                                    >
                                        Supprimé
                                    </v-chip>
                                </td>

                                <td
                                    v-else-if="
                                        isAccountingUser &&
                                        props.item.reconciliationStatus &&
                                        props.item.reconciliationStatus.accountableAccounts.length
                                    "
                                    @click.stop="onAccountableAccountClick(props.item)"
                                >
                                    <v-chip
                                        v-for="(accountableAccount, index) in props.item
                                            .reconciliationStatus.accountableAccounts"
                                        :key="index"
                                        class="px-2"
                                        label
                                        variant="outlined"
                                        :color="
                                            !accountableAccount.name.startsWith('471000') &&
                                            !accountableAccount.name.startsWith('XXXX')
                                                ? 'green'
                                                : 'red'
                                        "
                                        size="x-small"
                                        v-tooltip="accountableAccount.description"
                                    >
                                        {{ accountableAccount.name }}
                                    </v-chip>
                                    <v-chip
                                        v-if="
                                            !props.item.reconciliationStatus.accountableAccounts
                                                .length
                                        "
                                        class="px-2"
                                        label
                                        variant="outlined"
                                        :color="'red'"
                                        size="x-small"
                                        v-tooltip="'Inconnu'"
                                    >
                                        {{ 471000 }}
                                    </v-chip>
                                </td>
                                <td
                                    v-else-if="
                                        isAccountingUser &&
                                        props.item.reconciliationStatus.allocationSuggestion
                                    "
                                >
                                    <v-chip
                                        class="px-2"
                                        label
                                        variant="outlined"
                                        color="magic"
                                        @click.stop="
                                            openAccountableAccountWithSuggestion(props.item)
                                        "
                                        size="x-small"
                                        v-tooltip="props.item.fullSuggestionDescription"
                                    >
                                        {{
                                            props.item.reconciliationStatus.allocationSuggestion
                                                .accountableAccount.name
                                        }}
                                        <v-icon class="ml-1" size="x-small">$fa-magic</v-icon>
                                    </v-chip>
                                </td>
                                <td
                                    class="text-center"
                                    @click.stop="onAccountableAccountClick(props.item)"
                                    v-else
                                >
                                    <!-- <v-btn v-if="props.item.toJustify">
                                        A justifier
                                    </v-btn> -->
                                    <v-chip
                                        class="px-2"
                                        :class="{
                                            hasDocumentOrValidatedStatus:
                                                props.item.reconciliation?.documents?.filter(
                                                    (doc) => typeof doc.original !== 'undefined',
                                                ).length ||
                                                props.item.linkedDocuments?.filter(
                                                    (doc) => doc.status === 'VALIDATED',
                                                ).length,
                                        }"
                                        variant="outlined"
                                        label
                                        v-if="
                                            props.item.statusIndice &&
                                            props.item.statusIndice === 'INFORMATION_REQUEST' &&
                                            !isAccountingUser
                                        "
                                        size="x-small"
                                    >
                                        Demande d'information
                                    </v-chip>
                                    <v-chip
                                        class="px-2"
                                        variant="outlined"
                                        label
                                        v-else-if="props.item.toJustify"
                                        size="x-small"
                                    >
                                        A justifier
                                    </v-chip>
                                    <!-- <v-badge
                                        dot
                                        color="primary"
                                        class="font-weight-bold"
                                        v-else-if="!props.item.allocation"
                                    >
                                    </v-badge> -->
                                    <v-chip
                                        class="px-2"
                                        variant="outlined"
                                        color="red"
                                        label
                                        v-else-if="
                                            !props.item.reconciliationStatus.category &&
                                            !props.item.allocation
                                        "
                                        size="x-small"
                                    >
                                        A affecter
                                    </v-chip>
                                    <v-chip
                                        class="px-2"
                                        variant="outlined"
                                        color="secondary"
                                        label
                                        v-else
                                        size="x-small"
                                    >
                                        {{
                                            props.item.reconciliationStatus.category ||
                                            props.item.allocation
                                        }}
                                    </v-chip>
                                    <!-- <div class="font-weight-bold" v-else>
                                        {{ props.item.allocation }}
                                    </div> -->
                                </td>
                                <!-- <td
                                    class="text-center"
                                    :style="props.item.dateR !== props.item.date ? 'color:red;':''"
                                    v-if="isAccountingUser"
                                >{{ formatDateForUI(props.item.dateR) }}</td> -->

                                <td
                                    class="pr-2 text-center"
                                    v-if="showStatus"
                                    @click.stop="onReconciliationClick(props.item)"
                                >
                                    <v-tooltip
                                        :key="showBncAssignDocumentDialog.toString()"
                                        v-if="props.item.status !== 'DELETED'"
                                        location="start"
                                    >
                                        <template v-slot:activator="{ props: ttProps }">
                                            <v-btn-icon
                                                :icon="reconciliationIcon(props.item)"
                                                v-bind="ttProps"
                                                :color="reconciliationColor(props.item)"
                                                size="small"
                                            >
                                            </v-btn-icon>
                                        </template>
                                        <span>{{ reconciliationTooltip(props.item) }}</span>
                                    </v-tooltip>
                                </td>

                                <!--
                                    //
                                    // Raccourci vers le(s) document(s) liés au BT en mode compta d'engagement uniquement
                                    //
                                -->
                                <td
                                    class="pr-2 text-center"
                                    v-if="showStatus && !isIncomingOutgoingPayment"
                                    @click.stop="onLinkedDocumentClick(props.item)"
                                >
                                    <v-tooltip
                                        v-if="props.item.status !== 'DELETED'"
                                        location="start"
                                    >
                                        <template #activator="{ props: ttProps }">
                                            <v-btn-icon
                                                :icon="linkedDocumentIcon(props.item)"
                                                v-bind="ttProps"
                                                :color="linkedDocumentColor(props.item)"
                                                size="small"
                                            >
                                            </v-btn-icon>
                                        </template>
                                        <span>{{ linkedDocumentTooltip(props.item) }}</span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                    </oss-data-table>
                </v-col>
                <!-- <v-col cols="4" v-if="bankTransactionIdOpen">
                    <Reconciliation v-bind="openLine" />
                </v-col> -->
            </v-row>
            <template v-else>
                <v-row
                    class="d-flex justify-center"
                    style="max-height: calc(100vh - 226px); overflow-y: auto"
                    no-gutters
                >
                    <v-col cols="12" class="py-1" v-for="(item, index) in items" :key="index">
                        <v-card
                            elevation="0"
                            class="pa-2"
                            style="border-radius: 8px"
                            @click="onItemClick(item)"
                        >
                            <v-row no-gutters style="flex-wrap: nowrap">
                                <v-col
                                    style="
                                        min-width: 100px;
                                        max-width: 100%;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                    "
                                    class="flex-grow-1 flex-shrink-0"
                                >
                                    {{ item.wordingDisplay || item.wordingOriginal }}
                                </v-col>
                                <v-col
                                    style="min-width: 100px; max-width: 100%"
                                    class="flex-grow-0 flex-shrink-1 d-flex justify-end"
                                >
                                    <span
                                        :class="
                                            item?.amount > 0
                                                ? 'font-weight-bold primary--text'
                                                : 'text-red font-weight-bold'
                                        "
                                    >
                                        {{ newCommonFormatCurrency(item.amount, undefined) }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row no-gutters style="flex-wrap: nowrap">
                                <v-col
                                    style="
                                        min-width: 100px;
                                        max-width: 100%;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                    "
                                    class="flex-grow-0 flex-shrink-1"
                                >
                                    <v-icon color="secondary" size="small" location="start"
                                        >$oss-calendar</v-icon
                                    >
                                    {{ formatDateMobile(item.date) }}
                                </v-col>
                                <v-col
                                    :class="
                                        'flex-grow-1 flex-shrink-1 d-flex justify-end align-center ' +
                                        'text-' +
                                        progressCircularColor(item.statusIndice)
                                    "
                                >
                                    <v-badge
                                        dot
                                        inline
                                        :color="progressCircularColor(item.statusIndice)"
                                        class="mr-1"
                                        floating
                                    />
                                    {{ stateTooltip(item) }}
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <!-- <v-col v-if="$vuetify.display.mobile" :cols="$vuetify.display.mobile ? '12' : '10'" class="py-0 d-flex">
                        <oss-card
                            v-if="!bankTransaction.header"
                            :icon="btIcon(bankTransaction)"
                            :icon-color="btColor(bankTransaction)"
                            :amount="bankTransaction.amount"
                            :amount-style="$vuetify.display.mobile ? 'font-weight-black align-center justify-self-center pr-2' : 'title font-weight-black pr-2'"
                            :tag-text="bankTransaction.allocation || stateTooltip(bankTransaction)"
                            :tag-style="$vuetify.display.mobile ? 'elevation-0 pa-1 mr-2 text-center' : 'elevation-0 pa-1 mr-2 text-center v-size--small'"
                            rounded-tag
                            :unclickableTag="true"
                            :outlined-tag="bankTransaction.outlined"
                            @click:all="onItemClick(bankTransaction)"
                        >
                            <template #left>
                                <v-row v-if="$vuetify.display.mobile" no-gutters>
                                    <v-col
                                        class="d-flex align-center primary--text pt-2"
                                    >
                                        <span
                                            style="white-space: nowrap; overflow: hidden;"
                                        >{{ bankTransaction.wordingDisplay || bankTransaction.wordingOriginal }}</span>
                                    </v-col>
                                    <v-col cols="12" class="d-flex overline pb-2">
                                        <span>
                                            <v-icon  size="small" color="secondary" left>$oss-calendar</v-icon>
                                            {{ formatDateMobile(bankTransaction.date) }}
                                        </span>
                                    </v-col>
                                </v-row>
                                <v-row v-else no-gutters>
                                    <v-col style="d-flex align-center">
                                        <span style="font-weight: bold; font-size: 12pt;">
                                            {{ bankTransaction.wordingDisplay || bankTransaction.wordingOriginal }}
                                        </span>
                                    </v-col>
                                    <v-col style="max-width: fit-content">
                                        <span v-if="bankTransaction.date">
                                            <v-icon  size="small" color="secondary" left>$oss-calendar</v-icon> {{ formatDateMobile(bankTransaction.date) }}
                                        </span>
                                    </v-col>

                                    <v-col cols="12" class="py-0 pt-1">
                                        <v-icon  size="small" color="primary" left>{{getTransactionTypeIcon(bankTransaction)}}</v-icon>{{getTransactionTypeText(bankTransaction)}}
                                        <div v-if="bankTransaction.suppliers"><v-icon  size="small" left>$bookmark</v-icon>Fournisseur : {{ bankTransaction.suppliers }}</div>
                                        <div v-if="bankTransaction.customers"><v-icon  size="small" left>$bookmark</v-icon>Client : {{ bankTransaction.customers }}</div>
                                        <div v-if="bankTransaction.chatStatus"><v-icon  size="small" left  :style="'color:'+bankTransaction.chatStatusColor">$fa-comments</v-icon>
                                        <a :style="'color:'+bankTransaction.chatStatusColor">{{bankTransaction.chatStatus}}</a></div>
                                    </v-col>
                                </v-row>
                            </template>
                        </oss-card>
                    </v-col> -->
                    <v-col
                        cols="12"
                        class="pa-0 d-flex justify-center"
                        v-if="
                            items && items.length && items.length - nbrDates < pagination.totalItems
                        "
                    >
                        <oss-card :skeleton="true" v-intersect="onIntersectNext">
                            <template #left />
                        </oss-card>
                    </v-col>
                </v-row>
            </template>

            <ImportBankMain
                v-model="importWizard"
                @close="importWizard = false"
                :selectedAccountId="selectedAccount"
                @bankTransactionImported="refresh()"
                v-if="importWizard"
            />
            <!-- Without invoice -->
            <oss-dialog
                v-model="showWithoutInvoiceDialog"
                :title="'Sans facture'"
                :actions="withoutInvoiceActions"
                v-if="showWithoutInvoiceDialog"
                width="800px"
            >
                <WithoutInvoice
                    :companyId="selectedCompany.id"
                    :bts="withoutInvoiceBTS"
                    :actions="withoutInvoiceActions"
                    @added="
                        showWithoutInvoiceDialog = false;
                        refresh();
                    "
                >
                </WithoutInvoice>
            </oss-dialog>
            <!-- I O P  BankTransaction Dialog-->
            <IOPBankTransactionDialog
                v-model="showBncAssignDocumentDialog"
                :selectedCompany="selectedCompany"
                :selectedBankTransaction="selectedBankTransaction"
                @bankTransactionChanged="
                    refresh();
                    showBncAssignDocumentDialog = false;
                "
                v-if="showBncAssignDocumentDialog"
            >
            </IOPBankTransactionDialog>
            <!-- Z Till Receipt -->
            <oss-dialog
                v-model="showZTillDialog"
                title="Affectation à un Z de caisse"
                validTitle="Oui, je suis sûr(e)"
                @valid="executeZTillReconciliation()"
                width="800px"
            >
                <span class="body-1 text-center"
                    >&#xca;tes-vous sûr(e) de vouloir affecter les mouvements bancaires à un z de
                    caisse ?</span
                >
            </oss-dialog>
            <!-- Z Till Receipt -->
            <oss-dialog
                v-model="showDeallocateDialog"
                title="Retirer le ou les affectation(s) des comptes comptables"
                validTitle="Retirer"
                :loading="deallocateReconciliationLoading"
                @valid="deallocateBankTransactions()"
                width="800px"
            >
                <v-radio-group
                    v-model="deallocationChoice"
                    column
                    v-if="showDeallocationChoice"
                    color="primary"
                >
                    <div class="body-1">Retirer le ou les compte(s) comptable(s) de ?</div>
                    <v-radio label="la sélection" value="SELECTION" />
                    <v-radio
                        :label="'des ' + pagination.totalItems + ' mouvements de la recherche'"
                        value="ALL"
                    />
                </v-radio-group>
                <div class="pt-2">
                    {{
                        (deallocationChoice === "SELECTION"
                            ? enableDeallocationSelection
                            : pagination.totalItems) + " mouvement(s) bancaire(s) impacté(s)"
                    }}
                </div>
            </oss-dialog>
            <!-- Suppression -->
            <oss-dialog
                v-model="showDeleteBankTransactionsDialog"
                title="Suppression"
                validTitle="Oui, je suis sûr(e)"
                valid-class="error"
                @valid="deleteBankTransactions()"
                width="800px"
            >
                <h4 class="text-center" v-if="!stepData || !stepData.action">
                    &#xca;tes-vous sûr(e) de vouloir supprimer les mouvements bancaires ?
                </h4>
                <h4 class="text-center" v-if="stepData && !!stepData.action">
                    Suppression en cours
                </h4>
                <v-progress-linear
                    color="secondary"
                    height="10"
                    buffer-value="0"
                    v-if="stepData && !!stepData.action"
                    stream
                    class="ml-2"
                    :model-value="stepData.progressValue"
                />
            </oss-dialog>
            <!-- Not Deleted -->
            <oss-dialog
                v-model="showNoDeletedBankTransactionsDialog"
                title="Attention"
                validTitle="Accepter"
                @valid="
                    showNoDeletedBankTransactionsDialog = false;
                    notDeleted.length = 0;
                "
                width="800px"
            >
                <div v-if="notDeleted.length === 1" class="body-1 text-center">
                    Le mouvement bancaire n'a pas été éliminé car il est antérieur à la date
                    autorisée. ({{ listOfUnacceptedDates[0].lastDate }})
                </div>
                <div v-else class="body-1 text-center">
                    <p>
                        {{ notDeleted.length }} mouvements bancaires n'ont pas été éliminés car ils
                        sont antérieurs à la date autorisée.
                    </p>
                    <div v-for="(item, index) in listOfUnacceptedDates" :key="index">
                        {{ item.name }} ({{ item.lastDate }})
                    </div>
                </div>
            </oss-dialog>
            <!-- Type de transaction -->
            <oss-dialog
                v-model="showTransactionTypeDialog"
                title="Choisissez le type de transaction"
                validTitle="Valider"
                @valid="modifyTransactionType()"
                @close="closeTransactionTypeDialog()"
                :validLoading="transactionTypeLoading"
                width="800px"
            >
                <v-row no-gutters>
                    <v-col>
                        <v-select-filled
                            outlined
                            v-model="transactionType"
                            :items="transactionTypes"
                            item-title="text"
                            :hide-details="true"
                            density="compact"
                        />
                    </v-col>
                </v-row>
            </oss-dialog>
            <!-- bt wording -->
            <BankTransactionEdition
                v-model="editBankTransactionDialog"
                :bankTransaction="selectedBankTransaction"
                :companyId="selectedCompany.id"
                @updated="refresh()"
                v-if="editBankTransactionDialog"
            >
            </BankTransactionEdition>
            <!-- auto Sales -->
            <oss-dialog
                v-model="autoSalesReconciliationDialog"
                :title="'Encaissement'"
                :actions="autoSalesActions"
                width="800px"
            >
                <AutoSales
                    :companyId="selectedCompany.id"
                    :externalValidation="true"
                    :actions="autoSalesActions"
                    @create="onAutoSalesCreate"
                    @cancel="autoSalesReconciliationDialog = false"
                >
                </AutoSales>
            </oss-dialog>

            <ThirdPartyCompany
                v-model="thirdPartyDialog"
                :companyId="selectedCompany.id"
                :companyType="companyType"
                :bankTransactions="selected"
                :activateFreeTag="true"
                @added="onThirdPartyAdded()"
                v-if="thirdPartyDialog"
            >
            </ThirdPartyCompany>
            <CreateBTChatMessage
                v-model:active="showCreateBankTransactionMessageDialog"
                :companyId="selectedCompany.id"
                :bankTransactions="selectedBankTransactionsForMessage"
                @message-created="refresh"
            >
            </CreateBTChatMessage>
            <oss-dialog
                v-model="bncDocumentDialog"
                :withoutHeader="true"
                min-height="95vh"
                transition="dialog-bottom-transition"
                v-if="bncDocumentDialog"
                min-width="95vw"
            >
                <v-row class="d-flex justify-center">
                    <v-col cols="12" style="overflow-y: auto">
                        <document
                            :mode="'Reconciliation'"
                            :companyId="selectedCompany.id"
                            :id="getLinkedDocumentId(selectedBankTransaction)"
                            :dark-mode="true"
                            @task-ended="onDocumentValidated"
                        />
                    </v-col>
                </v-row>
            </oss-dialog>
            <oss-dialog
                v-model="documentDialog"
                :withoutHeader="true"
                min-height="95vh"
                transition="dialog-bottom-transition"
                v-if="documentDialog"
                min-width="95vw"
            >
                <v-row no-gutters class="d-flex justify-center">
                    <v-col cols="12" style="overflow-y: auto">
                        <document
                            :mode="'Reconciliation'"
                            :companyId="selectedCompany.id"
                            :id="linkedDocumentShown"
                            :dark-mode="true"
                            @task-ended="onDocumentValidated"
                        />
                    </v-col>
                </v-row>
                <div class="text-center" v-if="linkedDocumentsIds.length > 1" style="z-index: 1">
                    <div class="bottom-sheet">
                        <div class="remote" style="pointer-events: auto">
                            <v-container class="controller" elevation-1>
                                <v-btn-prev
                                    :disabled="previousDisabled()"
                                    @click.stop="previous()"
                                />
                                <v-btn-next :disabled="nextDisabled()" @click.stop="next()" />
                            </v-container>
                        </div>
                    </div>
                </div>
            </oss-dialog>

            <AccountableAccountVue
                title="Valider l'affectation"
                :showLabel="true"
                :showValidation="false"
                :needValidation="true"
                :companyId="selectedCompany.id"
                inAccountableAccountType="Selected"
                :embeddedInput="true"
                :editAccountableAccount="true"
                :defineThirdParty="true"
                :activateFreeTag="true"
                :bankTransactionId="selectedBankTransaction.id"
                :startOpenDialog="true"
                @dialogClosed="accountableAccountWithSuggestion = false"
                @validated="setAccountableAccountWithSuggestion($event)"
                :btn-mode="true"
                v-if="accountableAccountWithSuggestion"
            />

            <oss-dialog
                v-model="dialogDeletePermanentlySelectedBTs"
                title="Supprimer les flux bancaires selectectionnés définitivement"
                @valid="deleteBankTransactions(true)"
                width="800px"
            >
                <div class="text-center">
                    <h4>
                        Voulez-vous supprimer définitivement {{ selected.length }} flux bancaire{{
                            selected.length === 1 ? "" : "s"
                        }}
                        ?
                    </h4>
                </div>
            </oss-dialog>
        </template>
    </v-container>
</template>

<script lang="ts">
import ImportBankMain from "./bank/import-bank/ImportBankMain.vue";
import AccountableAccountVue from "./AccountableAccount.vue";
import ThirdPartyCompany from "./reconciliation/ThirdPartyCompany.vue";
import OssFilterBar from "./ossComponents/ossFilterBar.vue";
import AutoSales from "./reconciliation/AutoSales.vue";
import CreateBTChatMessage from "./chat/CreateBTChatMessage.vue";
import WithoutInvoice from "./reconciliation/WithoutInvoice.vue";
// import Reconciliation from "./Reconciliation.vue";
import Document from "./document/DocumentRouter.vue";
import IOPBankTransactionDialog from "./IOPBankTransactionDialog.vue";
import BankTransactionEdition from "./BankTransactionEdition.vue";
import BankFlow from "./BankFlow.vue";
import FreeTag from "./tag/FreeTag.vue";
import MultipleFreeTagging from "./tag/MultipleFreeTagging.vue";
import TutorialButtonDialog from "./tutorial/TutorialButtonDialog.vue";
import AuditCheckAlertButton from "@/views/audit/AuditCheckAlertButton.vue";
import AuditCheckOkButton from "@/views/audit/AuditCheckOkButton.vue";
import BankReconciliationDiscrepancyDialog from "@/views/bank/BankReconciliationDiscrepancyDialog.vue";

import { BankBase } from "./BankBase";
import { Component, toNative } from "vue-facing-decorator";

import { formatDateForUI } from "@/helpers/date.helper";

@Component({
    components: {
        ImportBankMain,
        AccountableAccountVue,
        AutoSales,
        ThirdPartyCompany,
        CreateBTChatMessage,
        OssFilterBar,
        // Reconciliation,
        WithoutInvoice,
        Document,
        IOPBankTransactionDialog,
        BankTransactionEdition,
        BankFlow,
        FreeTag,
        MultipleFreeTagging,
        TutorialButtonDialog,
        AuditCheckAlertButton,
        AuditCheckOkButton,
        BankReconciliationDiscrepancyDialog,
    },
    methods: {
        formatDateForUI,
    },
})
export class Bank extends BankBase {
    showTag: boolean = true;

    get activateTagguing() {
        return true;
    }

    beforeMount() {
        // debugger
        if (this.$route.params.resetFilter || this.$route.query.resetFilter) {
            this.clearAllFilters();
        }
        if ((this.$route.params.withReconciliation as any) === false) {
            this.reconciliationStatus = "NOT_JUSTIFIED";
        } else if ((this.$route.query.withReconciliation as any) === false) {
            this.reconciliationStatus = "NOT_JUSTIFIED";
        }
        if (this.$route.params?.reconciliationStatus) {
            this.reconciliationStatus = this.$route.params.reconciliationStatus as string;
        } else if (this.$route.query?.reconciliationStatus) {
            this.reconciliationStatus = String(this.$route.query.reconciliationStatus);
        }
        // console.log(this.reconciliationStatus)
        if (this.$route.params.amountType) {
            if (
                this.$route.params.amountType &&
                this.amountTypes.find((at) => at.value === this.$route.params.amountType)
            ) {
                this.amountType = this.$route.params.amountType as string;
            }
        } else if (this.$route.query.amountType) {
            if (
                this.$route.query.amountType &&
                this.amountTypes.find((at) => at.value === this.$route.query.amountType)
            ) {
                this.amountType = String(this.$route.query.amountType);
            }
        }
        //
        // obsolete
        //
        if (this.$route.params.beginDate) {
            this.beginDate = this.$route.params.beginDate as string;
        }
        //
        // new version : with startDate
        //
        if (this.$route.params.startDate) {
            this.beginDate = this.$route.params.startDate as string;
        }

        if (this.$route.params.endDate) {
            this.endDate = this.$route.params.endDate as string;
        }

        if (this.$route.query.auditCheck) {
            this.auditCheck = this.$route.query.auditCheck as string;
        }
        // console.log(this.auditCheck)

        this.finishMounted();
        this.addListener("bankTransaction");
    }

    beforeDestroy() {
        this.removeListener();
    }

    onMultiTagguingApplied() {
        debugger;
        this.selected = [];
        this.refresh();
    }
}

export default toNative(Bank);
</script>

<style lang="scss" scoped>
.hasDocumentOrValidatedStatus {
    color: white;
    background-color: green;
}
</style>
